// @flow

import { type Receipt } from './types';
import { useIncomingPayment, getFinalReceipt, getReceipts, getStatus, getCountry } from '@tectonics/prs/incoming-payment';
import { getMainReceipt } from '@tectonics/prs/receipts';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { getSafeInstalmentByNumber, getInstalmentByEndUser } from './get-instalments';
import {getCryptocurrencyReceipt} from '@tectonics/prs/receipts/get-cryptocurrency-receipt';

export function useCurrentReceipt(): Receipt {
  const incomingPayment = useIncomingPayment();
  const [selectedPaymentMethodCode] = useUserInputValue('selectedPaymentMethod');
  const [selectedInstalment] = useUserInputValue('selectedInstalment');
  const country = getCountry(incomingPayment);

  const getBanktransferReceiptForAR = () => {
    if (['banktransfer'].includes(selectedPaymentMethodCode) && country === 'ar') {
      const receipts = getReceipts(incomingPayment);
      const instalments = getInstalmentByEndUser(receipts, selectedPaymentMethodCode, country, Number(selectedInstalment));
      if (instalments) {
        return instalments;
      }
    }
  };

  if (getStatus(incomingPayment) !== 'OP' && getStatus(incomingPayment) !== 'CA') {
    const banktransferResult = getBanktransferReceiptForAR();
    if (banktransferResult) {
      return banktransferResult;
    }
    return getFinalReceipt(incomingPayment);
  }

  const receipts = getReceipts(incomingPayment);

  if (['creditcard', 'google'].includes(selectedPaymentMethodCode)) {
    return getSafeInstalmentByNumber(receipts, Number(selectedInstalment));
  }

  const banktransferResult = getBanktransferReceiptForAR();
  if (banktransferResult) {
    return banktransferResult;
  }

  if (['cryptocurrency'].includes(selectedPaymentMethodCode)) {
    const cryptocurrencyReceipts =  getCryptocurrencyReceipt(receipts);
    if (cryptocurrencyReceipts) return cryptocurrencyReceipts;
  }

  return getMainReceipt(receipts);
}
